import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { SchedulingUtils } from '../shedulling.utils';
import { Schedule, Scheduling, WeekDay } from '../scheduling.model';
import { SCHEDULE_TYPE, ERROR, MODE, COMMAND, RULE_STATUS } from '../scheduling.constants';
import { GeneralService } from '../../../shared/services/general.service';
import { Device } from '../../devices/devices.model_new';
import * as moment from 'moment';
import { cloneDeep } from 'lodash';
import { HVACModel, HVAC } from '../../devices/devices.utils';
import { DeleteConfirmDialogComponent } from '../../../shared/components/delete-confirm-dialog/delete-confirm-dialog.component';
import { MatDialogRef, MatDialog } from '@angular/material';

@Component({
  selector: 'app-schedule-create',
  templateUrl: './schedule-create.component.html',
  styleUrls: ['./schedule-create.component.scss']
})
export class ScheduleCreateComponent implements OnInit {
  MAX_TEMP = 30;
  MIN_TEMP = 7;

  MAX_POWER = 100;
  MIN_POWER = 1;

  SchedulingUtils = SchedulingUtils;
  everyday = false;

  @Input()
  schedule: Schedule;
  @Input()
  scheduling: Scheduling;
  @Input()
  schedulingSK: Scheduling;
  @Input()
  schedulingEco: Scheduling;
  @Input()
  typesArray: SCHEDULE_TYPE[];
  @Input()
  deviceName: string;
  @Input()
  hvacModel: HVACModel;
  @Input()
  termostatModel: boolean;

  @Input()
  set errorMessage(errorMessage: string) {
    this._errorMessage = errorMessage;
    if (this._errorMessage != null && this._errorMessage !== '') {
      this.schedulingConflictError = true;
    }
  }

  SCHEDULING_TYPE = SCHEDULE_TYPE;

  _errorMessage: string;
  schedulingConflictError: boolean;
  conflicts: Schedule[] = [];

  mode: string;
  types: Map<SCHEDULE_TYPE, boolean>;
  buttonMode: string;
  changed: boolean;
  selectedMode: MODE;


  selectedFromTime: Date = new Date('1968-11-16T00:00:00');
  selectedToTime: Date = new Date('1968-11-16T00:00:00');

  @Output() emittedSchedule: EventEmitter<Schedule> = new EventEmitter<Schedule>();
  dialogDelRef: MatDialogRef<DeleteConfirmDialogComponent>;

  constructor(private generalService: GeneralService,
              private dialog: MatDialog) { }

  ngOnInit() {
    if (this.schedule !== undefined) {
      this.schedule = this.schedule;
      if (this.deviceName) {
        this.mode = this.deviceName.toLocaleUpperCase();
      } else {
        this.mode = this.generalService.translate.instant('EDIT SCHEDULE');
      } // if (this.schedule.getRuleStatus() === RULE_STATUS.REPORTED) {
      this.buttonMode = this.generalService.translate.instant('SAVE');
      /* } else {
         this.buttonMode = this.generalService.translate.instant('RETRY');
       }*/
    } else {
      this.schedule = new Schedule(this.typesArray[0]);
      if (this.deviceName) {
        this.mode = this.deviceName.toLocaleUpperCase();
      } else {
        this.mode = this.generalService.translate.instant('NEW SCHEDULE');
      }
      this.buttonMode = this.generalService.translate.instant('CREATE');
    }

    this.types = new Map<SCHEDULE_TYPE, boolean>();
    let first = true;
    for (const t of this.typesArray) {
      if (first) {
        first = false;
        this.types.set(t, true);
        this.schedule.setType(t);
      } else {
        this.types.set(t, false);
      }
    }
    if (this.schedule.getId() !== undefined) {
      this.selectedFromTime = new Date(`1970-01-01T${this.schedule.getFromTime()}`);
      this.selectedToTime = new Date(`1970-01-01T${this.schedule.getToTime()}`);
    }

    if (!this.schedule.getState() && this.schedule.getState() !== false) {
      this.schedule.setState(true);
    }

    if (!this.schedule.getPower()) {
      this.schedule.setPower(this.MIN_POWER);
    }

    if (this.schedule.getType().includes(SCHEDULE_TYPE.HVAC) && this.schedule.getMode()) {
      this.selectedMode = this.schedule.getMode();
    } else {
      this.setOperationMode(MODE.AUTO);
    }
    if (this.schedule.getType() === SCHEDULE_TYPE.ON_OFF && !this.schedule.getCommand()) {
      this.schedule.setCommand(COMMAND.ON);
    }
    this.everyday = this.everyDaySelected();
  }

  getTypeKeys(): SCHEDULE_TYPE[] {
    return Array.from(this.types.keys());
  }

  changeTypeSelection(schedulingType: SCHEDULE_TYPE): void {
    if (!this.types.get(schedulingType)) {
      this.schedule.getWeekDays().forEach(wd => wd.setSet(false));
      this.schedule.setFromTime('--:--');
      this.schedule.setToTime('--:--');
      this.schedulingConflictError = false;
      this.getTypeKeys().forEach(
        t => this.types.set(t, false)
      );
      this.types.set(schedulingType, true);
      this.schedule.setType(schedulingType);
      if (this.schedule.getType() === SCHEDULE_TYPE.ECONOMIC) {
        this.schedule.setFromTime('00:00');
        this.schedule.setToTime('00:00');
      }
    }
  }

  onClick(event) {
    // this.cleanForm();
    const appendId = setInterval(() => {
      if ($('.owl-dt-timer').length === 1) {
        $('.owl-dt-timer').css('display', 'flex');
        $('.owl-dt-container-inner').css('font-family', 'Roboto');
        $('.owl-dt-container-buttons button:nth-child(2) .owl-dt-control-button-content')
          .text(this.generalService.translate.instant('Set'));
        clearInterval(appendId);
      }
    }, 0);
  }

  hasSetpoint(): boolean {
    return this.types.get(SCHEDULE_TYPE.HVAC) || this.types.get(SCHEDULE_TYPE.THERMOSTAT);
  }

  isStandByKillerType(): boolean {
    return this.schedule.getType() === SCHEDULE_TYPE.STAND_BY_KILLER;
  }

  isHVACType(): boolean {
    return this.schedule.getType() === SCHEDULE_TYPE.HVAC;
  }

  isTermostatType(): boolean {
    return this.schedule.getType() === SCHEDULE_TYPE.THERMOSTAT;
  }
  isOnOffType(): boolean {
    return this.schedule.getType() === SCHEDULE_TYPE.ON_OFF;
  }

  onChangeTime(isFrom: boolean) {
    this.changed = true;
    if (isFrom) {
      const time = moment(this.selectedFromTime).format('HH:mm');
      this.schedule.setFromTime(time);
    } else {
      const time = moment(this.selectedToTime).format('HH:mm');
      this.schedule.setToTime(time);
    }
  }

  onIncreaseTemp() {
    if (this.schedule.getTemperature() < this.MAX_TEMP) {
      this.schedule.setTemperature(this.schedule.getTemperature() + 1);
      this.changed = true;
    }
  }

  onDecreaseTemp() {
    if (this.schedule.getTemperature() > this.MIN_TEMP) {
      this.schedule.setTemperature(this.schedule.getTemperature() - 1);
      this.changed = true;
    }
  }

  onIncreasePower() {
    if (this.schedule.getPower() < this.MAX_POWER) {
      this.schedule.setPower(this.schedule.getPower() + 1);
      this.changed = true;
    }
  }

  onDecreasePower() {
    if (this.schedule.getPower() > this.MIN_POWER) {
      this.schedule.setPower(this.schedule.getPower() - 1);
      this.changed = true;
    }
  }

  onSetCommand() {
    if (this.schedule.getCommand() === COMMAND.OFF) {
      this.schedule.setCommand(COMMAND.ON);
    } else {
      this.schedule.setCommand(COMMAND.OFF);
    }
    this.changed = true;
  }

  onToogleWeekDay(weekday: WeekDay) {
    if (!weekday.getSet() === false) {
      this.everyday = false;
    }
    weekday.setSet(!weekday.getSet());
    this.changed = true;
  }

  isDisabled(): boolean {
    return this.schedule.getWeekDays().find(d => d.getSet()) === undefined ||
      ((this.schedule.getFromTime().includes('--') || this.schedule.getToTime().includes('--')) &&
        this.schedule.getType() !== SCHEDULE_TYPE.ECONOMIC) ||
      (this.isEdit() && !this.changed);
  }

  isEdit(): boolean {
    return this.buttonMode === this.generalService.translate.instant('SAVE');
  }

  isRetry(): boolean {
    return this.buttonMode === this.generalService.translate.instant('RETRY');
  }

  onCreateSchedule(): void {
    this.cleanForm();
    const newSchedule: Schedule = cloneDeep(this.schedule);
    this.emittedSchedule.emit(newSchedule);
  }

  setOperationMode(value: string) {
    this.selectedMode = <MODE>value;
    this.schedule.setMode(<MODE>value);
    this.changed = true;
  }

  isModeSelected(value: string) {
    return this.selectedMode === value;
  }

  onDeleteSchedule(): void {
      this.dialogDelRef = this.dialog.open(DeleteConfirmDialogComponent, {
        data: {
          element: 'SCHEDULE',
          message: `Schedule ${this.schedule.getType()} with horary: ${this.schedule.getHorary()}
          ${this.generalService.translate.instant('will be permanently deleted.')}`,
          small: true
        },
        autoFocus: false,
        panelClass: 'deleteGenericPopup'
      });

      const sub = this.dialogDelRef.componentInstance.action
        .subscribe((toDelete: boolean) => {
          if (toDelete) {
            this.schedule.toDelete = true;
            this.emittedSchedule.emit(this.schedule);
          }
        });
  }

  private cleanForm(): void {
    this.schedulingConflictError = false;
    this.conflicts = [];
  }

  getScheduleState() {
    return this.schedule.getState();
  }

  changeState() {
    this.schedule.setState(!this.schedule.getState());
    this.changed = true;
  }

  everyDaySelected() {
    let state = true;
    if (this.schedule) {
      this.schedule.getWeekDays().forEach(day => {
        if (!day.getSet()) {
          state = false;
        }
      });
    }
    return state;
  }

  toggleEveryday() {
    if (!this.everyday) {
      this.schedule.getWeekDays().forEach(day => {
        day.setSet(true);
       });
       this.everyday = true;
    } else {
      this.schedule.getWeekDays().forEach(day => {
        day.setSet(false);
       });
       this.everyday = false;
    }
    this.changed = true;
  }

  changeHandler(val) {
    if (val.schedule.power < 1) {

      val.schedule.power = 1;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/scheduling/schedule-create/schedule-create.component.ts